import { render, staticRenderFns } from "./ProfileShowcase.vue?vue&type=template&id=150c8b40&scoped=true"
import script from "./ProfileShowcase.vue?vue&type=script&lang=js"
export * from "./ProfileShowcase.vue?vue&type=script&lang=js"
import style0 from "./ProfileShowcase.vue?vue&type=style&index=0&id=150c8b40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150c8b40",
  null
  
)

export default component.exports